export default __webpack_public_path__ + "static/media/home_bg.ef13de69.png";